import { useQuery } from "@tanstack/react-query";
import { searchGlobal, type GlobalSearchResults } from "../api/search";

export const SEARCH_MIN_QUERY = 2;
export const SEARCH_DEBOUNCE_MS = 200;

export function useGlobalSearch(q: string) {
  return useQuery<GlobalSearchResults>({
    queryKey: ["search", q],
    queryFn: () => searchGlobal(q),
    enabled: q.length >= SEARCH_MIN_QUERY,
    staleTime: 60_000,
  });
}
